import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ClientDetails, ClientResponse } from '../app/models/client.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientService {

  constructor(private http: HttpClient) {}

  getClients(): Observable<ClientResponse> {
    return this.http.get<ClientResponse>(
      `${environment.baseUrl}/admin/clients`
    );
  }

  getClientById(id: string): Observable<ClientDetails> {
    return this.http.get<ClientDetails>(`${environment.baseUrl}/admin/clients/${id}`);
  }

  createClient(payload: any): Observable<ClientDetails> {
    return this.http.post<ClientDetails>(
      `${environment.baseUrl}/admin/clients`,
      payload
    );
  }

  updateClient(id: string, payload: any): Observable<ClientDetails> {
    return this.http.put<ClientDetails>(`${environment.baseUrl}/admin/clients/${id}`, payload);
  }

  deleteClient(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.baseUrl}/admin/clients/${id}`);
  }

  getAuthorizationGrantTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.baseUrl}/admin/clients/filters/authorizationGrantTypes`);
  }
}